import { render } from "./PageA.vue?vue&type=template&id=48651d0a"
import script from "./PageA.vue?vue&type=script&lang=js"
export * from "./PageA.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__